exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hide-buttons[data-v-00e28db4] {\n  opacity: 0;\n}", ""]);

// exports
